module.exports = __webpack_public_path__ + "img/games-4.7f37d591.webp";